<template>
  <li
    aria-haspopup="true"
    data-menu-toggle="hover"
    class="menu-item"
    :class="{
      'menu-item-submenu': hasChildren,
      'menu-item-open': hasChildren && isGroupActive,
      'menu-item-active': !hasChildren && isDirectActive,
    }"
  >
    <template v-if="hasChildren">
      <a href="#" class="menu-link menu-toggle">
        <i :class="[item.icon, 'menu-icon', 'mr-5']"></i>
        <span class="menu-text">{{ item.label }}</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <router-link
            v-for="child in item.children"
            :key="child.to"
            :to="child.to"
            custom
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              class="menu-item"
              :class="[
                childActive(child, isActive, isExactActive) && 'menu-item-active',
              ]"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text">{{ child.label }}</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </template>

    <a v-else :href="item.to" class="menu-link" @click.prevent="navigateDirect">
      <i :class="[item.icon, 'menu-icon', 'mr-5']"></i>
      <span class="menu-text">{{ item.label }}</span>
    </a>
  </li>
</template>

<script>
export default {
  name: "SidebarMenuItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasChildren() {
      return Boolean(this.item.children && this.item.children.length);
    },
    isGroupActive() {
      return (this.item.children || []).some((child) => {
        if (child.to.includes("?")) return this.$route.fullPath === child.to;
        return this.$route.path.startsWith(child.to);
      });
    },
    isDirectActive() {
      if (!this.item.to) return false;
      return this.item.exact
        ? this.$route.fullPath === this.item.to
        : this.$route.path.startsWith(this.item.to);
    },
  },
  methods: {
    childActive(child, isActive, isExactActive) {
      if (child.to.includes("?")) return this.$route.fullPath === child.to;
      if (this.$route.path === child.to && this.$route.query.tab === "packages") return false;
      return isActive || isExactActive;
    },
    navigateDirect() {
      if (this.item.to && this.$route.path !== this.item.to) {
        this.$router.push(this.item.to);
      }
    },
  },
};
</script>
